import type { HeadlessContent, Content } from '../../@types/EditorContentTypes';

export const mapHeadlessContent = (content: Content | HeadlessContent): Content => {
  if ('__type' in content && content.__type === 'aem-headless') {
    const normalizedContent: Content = {
      priceDisplayOption: {
        showBasePrice: content.fields.priceDisplayOption_showBasePrice,
        showVat: content.fields.priceDisplayOption_showVat,
      },
      caeDisplayOption: {
        showCae: content.fields.caeDisplayOption_showCae,
      },
      ctaDisplayOptions: {
        showConfigureCTA: content.fields.ctaDisplayOptions_showConfigureCTA,
        isDiscoverPrimaryBtn: content.fields.ctaDisplayOptions_isDiscoverPrimaryBtn,
        showNewCarsCTA: content.fields.ctaDisplayOptions_showNewCarsCTA,
        showUsedCarsCTA: content.fields.ctaDisplayOptions_showUsedCarsCTA,
      },
      priceFootnotes: content.fields.priceFootnotes,
      quickActions: {
        exploreModelsUrl: content.fields.quickActions_exploreModelsUrl,
        compareModelsUrl: content.fields.quickActions_compareModelsUrl,
      },
    };
    return normalizedContent;
  }
  return content as Content;
};
